import React from 'react';
import {
  StyledPara,
  StyledPanel,
  StyledCollapse,
  StyledContentWrapper,
  TableHeaderWrapper,
} from './styled';
import RenderMetadataGroup from './renderMetadataGroup';
import Tile from './Tile';

const ContentMetadata = ({ streamUrl, contentMetadata }) => (
  <StyledContentWrapper>
    <TableHeaderWrapper>
      Content Metadata
    </TableHeaderWrapper>
    <StyledCollapse bordered={false}>
      <StyledPanel showArrow={false} header={<Tile name="Stream URL" value="Show URL" showDivider={false} />} key="1">
        <StyledPara>{streamUrl}</StyledPara>
      </StyledPanel>
    </StyledCollapse>
    <RenderMetadataGroup
      metadataGroup={contentMetadata}
    />
  </StyledContentWrapper>

);

export default ContentMetadata;
